<template>
  <div v-if="loading_page" class="p-4">
    <loader />
  </div>
  <div v-if="!loading_page" class="p-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="text-2xl font-bold">Insurance Company Schemes</h2>
      <button class="btn btn-primary" @click="showAddModal = true">
        ➕ Add Scheme
      </button>
    </div>

    <table class="table table-striped table-bordered shadow-sm">
      <thead class="thead-dark">
        <tr>
          <th>#</th>
          <th>Scheme Name</th>
          <!-- <th>Limit</th>
          <th>Status</th> -->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="schemes.length === 0">
          <td colspan="3" class="text-center text-muted py-4">
            📭 No insurance schemes found.
          </td>
        </tr>
        <tr v-else v-for="(scheme, index) in schemes" :key="scheme.id">
          <td>{{ index + 1 }}</td>
          <td>{{ scheme.scheme_name }}</td>
          <td>
            <button
              class="btn btn-sm btn-danger"
              @click="deleteScheme(scheme.id)"
            >
              🗑️ Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Add Scheme Modal -->
    <div
      class="modal fade"
      tabindex="-1"
      :class="{ show: showAddModal }"
      style="display: block"
      v-if="showAddModal"
    >
      <div class="modal-dialog">
        <div v-if="loading_modal" class="modal-content">
          <loader />
        </div>
        <div v-if="!loading_modal" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Scheme</h5>
            <button type="button" class="close" @click="showAddModal = false">
              &times;
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label>Scheme Name</label>
              <input
                type="text"
                class="form-control"
                v-model="newScheme.name"
              />
            </div>
            <!-- <div class="form-group">
              <label>Limit</label>
              <input
                type="number"
                class="form-control"
                v-model="newScheme.limit"
              />
            </div>
            <div class="form-group">
              <label>Status</label>
              <select class="form-control" v-model="newScheme.active">
                <option :value="true">Active</option>
                <option :value="false">Inactive</option>
              </select>
            </div> -->
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showAddModal = false">
              Close
            </button>
            <button class="btn btn-primary" @click="saveScheme">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "../../special_clinics/dialysis/loader.vue";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      showAddModal: false,
      schemes: [],
      newScheme: {
        name: "",
        limit: "",
        active: true,
      },
    };
  },
  components: {
    loader,
  },
  methods: {
    editScheme(scheme) {
      alert("Editing scheme: " + scheme.name);
    },
    async deleteScheme(id) {
      if (confirm("Are you sure you want to delete this scheme?")) {
        this.loading_page = true;
        await generalApiRequest(
          "insurance/org-schemes_delete/" + id,
          "POST",
          {},
          1
        );
        this.get_schemes();
        this.loading_page = false;
      }
    },
    async saveScheme() {
      if (!this.newScheme.name.trim()) return alert("Scheme name required");
      this.loading_modal = true;
      const req_body = {
        scheme_name: this.newScheme.name,
        insurance_company_id: this.$route.params.company,
      };
      await generalApiRequest("insurance/org-schemes", "POST", req_body, 1);
      this.showAddModal = false;
      this.get_schemes();
      this.loading_modal = false;
      this.newScheme = {
        name: "",
        limit: "",
        active: true,
      };
    },
    async get_schemes() {
      this.loading_page = true;
      const res = await generalApiRequest(
        "insurance/org-schemes/" + this.$route.params.company,
        "GET",
        {},
        1
      );
      this.schemes = res;
      this.loading_page = false;
    },
  },
  mounted() {
    this.get_schemes();
  },
};
</script>

<style>
.table a:hover {
  text-decoration: underline;
}
.modal.fade {
  background: rgba(0, 0, 0, 0.5);
}
</style>
